import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item1", "item2"]
  even = true

  connect() {
    console.log("toggle controller connect")
    console.log("item1", this.item1Target)
    if (this.hasItem2Target) console.log("item2", this.item2Target)
  }

  toggle() {
    console.log("toggle")
    if (this.even) {
      this.item1Target.classList.remove("hidden")
      if (this.hasItem2Target) this.item2Target.classList.add("hidden")
      console.log("item 1 show")
    } else {
      this.item1Target.classList.add("hidden")
      if (this.hasItem2Target) this.item2Target.classList.remove("hidden")
      console.log("item 1 hide")
    }
    this.even = !this.even
  }

  singleToggle(event) {
    console.log("single toggle")
    console.log(event.target)
    if (this.even) {
      this.item1Target.classList.remove("hidden")
    } else {
      this.item1Target.classList.add("hidden")
    }
    this.even = !this.even
  }

  // Chowa item1 gdy klik padł poza tym kontrolerem (opt-in przez
  // data-action="click@window->toggle#hideOnOutside"). Klik wewnątrz nic nie robi.
  hideOnOutside(event) {
    if (this.element.contains(event.target)) return

    this.item1Target.classList.add("hidden")
    this.even = true
  }

  // Pokaż/ukryj item1 na podstawie stanu checkboxa (checked = widoczny)
  checkboxToggle(event) {
    if (event.target.checked) {
      this.item1Target.classList.remove("hidden")
    } else {
      this.item1Target.classList.add("hidden")
    }
  }

  // Pokaż item1 gdy liczba wybrana w polu jest >= progu z data-toggle-threshold
  // (np. ostrzeżenie o wydajności przy dużej liczbie rekordów na stronie)
  thresholdToggle(event) {
    const threshold = parseInt(this.element.dataset.toggleThreshold)
    const value = parseInt(event.target.value)

    this.item1Target.classList.toggle("hidden", !(value >= threshold))
  }

  toggleOnFilled(event) {
    if (!this.hasItem2Target) return
    if (event.target.value !== "") {
      this.item2Target.classList.remove("hidden")
    } else {
      this.item2Target.classList.add("hidden")
    }
  }

  // Pokaż item2 i ukryj item1, ale tylko gdy wartość event.target jest pusta.
  // Używane gdy wybór z selecta "własny" (value="") odsłania alternatywny widok np. pole tekstowe.
  revealItem2OnEmpty(event) {
    if (event.target.value !== "") return

    this.item1Target.classList.add("hidden")
    if (this.hasItem2Target) this.item2Target.classList.remove("hidden")
    this.item2Target?.querySelector("input")?.focus()
  }

  // Pokaż item1 i ukryj item2 - powrót do widoku domyślnego.
  revealItem1(event) {
    if (event) event.preventDefault()
    this.item1Target.classList.remove("hidden")
    if (this.hasItem2Target) this.item2Target.classList.add("hidden")
  }
}
